import { setSearchTerm } from "../employeesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useEmployeeSearch = () => useSearch(s => s.data.listing.employees.searchTerm, setSearchTerm);
